// @flow

import React, { type Node } from 'react';
import { ShowPendingPageContent } from './pending-page-components';
import {
  Body,
  Content,
} from '../../../organisms/shared-styled-components';
import { MerchantInfo, MerchantLogo } from '../../../organisms/merchant-info';
import { MobileTotalAmount } from '../../../organisms/mobile-total-amount';

export function PendingPage(): Node {
  return (
    <Content>
      <MerchantLogo height="100px" />
      <MobileTotalAmount />
      <Body>
        <ShowPendingPageContent />
        <MerchantInfo />
      </Body>
    </Content>
  );
}
